// sharedState.js
import { reactive } from 'vue'

export const sharedState = reactive({
  mainLogoClicked: false,
  mainUpdate: false,
})